import { gql } from '@apollo/client';

export const CREATE_LESSONS = gql`
mutation CreateLessons ($input: CreateLessonsInput!) {
    createLessons(input: $input) {
        lesson_id
        book_id
      }
}
`;